export const environment = {
    production: false,
    apiUrl: 'https://dev2-ai-tcr-api.trinka.ai',
    reportDisplayTimezone: 'America/Los_Angeles',
};
